import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectThemeDomain = (state) => (state && state.theme) || initialState;

const selectSelectedTheme = createSelector(selectThemeDomain, (theme) => theme.selectedTheme);
const selectThemes = createSelector(selectThemeDomain, (theme) => theme.themes);

const selectCurrentTheme = createSelector(
    selectSelectedTheme,
    selectThemes,
    (selectedTheme, themes) => themes[selectedTheme] || themes.default,
);

export { selectThemeDomain, selectSelectedTheme, selectThemes, selectCurrentTheme };
